import Config from "../config";

/**
 * Tipi di utilità per i parametri comuni
 */
export type SearchHelper = 0 | 1 | 2 | 3 | 4 | 5 | null;
export type Timestamp = string | number | null;

export interface AbortableRequest<T = any> {
    abort: () => void;
    ready: (rawResponseCallback?: (res: Response) => void) => Promise<T | void>;
}

// Estensione globale per gestire safeSessionStorage se non definito nei tipi standard
declare global {
    interface Window {
        safeSessionStorage: Storage;
    }
}

export default class WadminApi {
    static setPublic(publickey: string): void {}

    static setBasicAuth(user: string, pass: string): void {}

    static setOperatorId(operatorId: number | null): void {
        ApiConfig.setOperatorId(operatorId);
    }

    static getOperatorId(): number | null {
        return ApiConfig.getOperatorId();
    }

    static setEndpoint(endpoint: string): void {
        ApiConfig.endpoint = endpoint;
    }

    /*
     * Chiamate Nuove che vanno implementate anche per la versione ccg
     */

    static callNewCustomerGiveBonus(
        id: string | number,
        currency: string,
        amount: number,
        charge: 'y' | 'n',
        note: string
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('newcustomer.givebonus'),
            ApiConfig.postAsGetData({
                id,
                currency,
                amount,
                charge,
                note
            })
        );
    }

    static callNewCustomerMain(id: string | number): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('newcustomer.main'),
            ApiConfig.postAsGetData({ id }),
            {}
        );
    }

    static callNewTransferMakeTransfer(
        id: string | number,
        currency: string,
        amount: number,
        charge: 'y' | 'n',
        type: string,
        note: string
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('newtransfer.makeTransfer'),
            ApiConfig.postAsGetData({
                id,
                currency,
                amount,
                charge,
                type,
                note
            }),
            {}
        );
    }

    static callNewTransferMain(id: string | number): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('newtransfer.main'),
            ApiConfig.postAsGetData({ id }),
            {}
        );
    }

    static callSubfinancialMainFinancial(
        searchHelper: SearchHelper = null,
        searchStartDate: Timestamp = null,
        searchEndDate: Timestamp = null,
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('subfinancial.mainFinancial'),
            ApiConfig.postAsGetData({
                searchHelper,
                searchStartDate,
                searchEndDate,
            }),
            {}
        );
    }

    static callTransactionsViewAllTransactions(
        lowlimit: number = 0,
        searchRecordPerPage: number | null = null,
        searchHelper: SearchHelper = null,
        searchStartDate: Timestamp = null,
        searchEndDate: Timestamp = null,
        searchExact: string | null = null,
        searchString: string | null = null,
        transType: string | null = null,
        opType: string | null = null,
        playerid: string | number | null = null
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('transactions.affiliateTransaction'),
            ApiConfig.postAsGetData({
                input: 'allTransactions',
                lowlimit,
                searchRecordPerPage,
                searchHelper,
                searchStartDate,
                searchEndDate,
                searchExact,
                searchString,
                transType,
                opType,
                playerid
            }),
            {}
        );
    }

    static callTransactionsAffiliateTransactionSearch(
        lowlimit: number = 0,
        searchRecordPerPage: number | null = null,
        searchHelper: SearchHelper = null,
        searchStartDate: Timestamp = null,
        searchEndDate: Timestamp = null,
        searchExact: string | null = null,
        searchString: string | null = null
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('transactions.affiliateTransaction'),
            ApiConfig.postAsGetData({
                input: 'affiliate',
                lowlimit,
                searchRecordPerPage,
                searchHelper,
                searchStartDate,
                searchEndDate,
                searchExact,
                searchString
            }),
            {}
        );
    }

    static callAdminuserChildren(id: string | number, allowskin: string | null = null): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('adminuser.children'),
            ApiConfig.postAsGetData({ id, allowskin }),
            {}
        );
    }

    static callCustomerMain(
        lowlimit: number = 0,
        searchRecordPerPage: number | null = null,
        searchType: number | string | null = null,
        searchExact: string | null = null,
        searchString: string | null = null,
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('customer.main'),
            ApiConfig.postAsGetData({
                lowlimit,
                searchRecordPerPage,
                searchType,
                searchExact,
                searchString,
            }),
            {}
        );
    }

    static callTicketCancel(ticketid: string | number): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('betting.ticketCancel'),
            ApiConfig.postAsGetData({ ticketid }),
            {}
        );
    }

    /*
     * Fine Chiamate nuove
     */

    static callBettingTickets(
        lowlimit: number = 0,
        searchRecordPerPage: number | null = null,
        orderby: string | null = null,
        ordertype: string | null = null,
        searchHelper: SearchHelper = null,
        searchStartDate: Timestamp = null,
        searchEndDate: Timestamp = null,
        useTicketEnd: any = null,
        searchStatus: any = null,
        searchSystemHide: any = null,
        searchType: any = null,
        searchExact: any = null,
        searchString: string | null = null,
        searchBetType: any = null,
        searchBetEvents: any = null,
        searchStock: any = null,
        searchForPrese: any = null,
        searchOutcome: any = null
    ): AbortableRequest {
        return makeAbortablePOST(
            ApiConfig.getEndpoint('betting.tickets'),
            ApiConfig.postAsGetData({
                lowlimit,
                searchRecordPerPage,
                orderby,
                ordertype,
                searchHelper,
                searchStartDate,
                searchEndDate,
                useTicketEnd,
                searchStatus,
                searchSystemHide,
                searchType,
                searchExact,
                searchString,
                searchBetType,
                searchBetEvents,
                searchStock,
                searchForPrese,
                searchOutcome
            }),
            {},
            (output: any) => {
                if (output && output.data && output.data.betlist) {
                    try {
                        output.data.betlist = JSON.parse(output.data.betlist);
                    } catch (e) {
                        console.error("Error parsing betlist", e);
                    }
                }
                return output;
            }
        );
    }
}

class ApiConfig {
    static get endpoint() {return Config.softionAPI + '/wadmin/index.php';};
    static set endpoint(v) {};
    
    static basicauth: string = '';
    static publickey: string = '';
    static operatorid: number | null = null;

    static getEndpoint(path: string): string {
        return this.endpoint + '?' + [
            'controller=api',
            'time=' + Math.floor(Date.now() / 1000),
            'op=' + path,
        ].join('&');
    }

    static objectToQuerystring(object: Record<string, any>): string {
        return Object.entries(object)
            .map(([k, v]) => v !== null ? k + '=' + encodeURIComponent(v) : null)
            .filter(item => item !== null)
            .join('&');
    }

    static postData(object: Record<string, any>): string {
        const data = Object.entries(object)
            .map(([k, v]) => v !== null ? 'post[' + k + ']' + '=' + encodeURIComponent(v) : null)
            .filter(item => item !== null) as string[];

        if (this.getOperatorId()) {
            data.push('operator-id=' + this.getOperatorId());
        }

        return data.join('&');
    }

    static postAsGetData(object: Record<string, any>): string {
        const data = Object.entries(object)
            .map(([k, v]) => v !== null ? 'get[' + k + ']' + '=' + encodeURIComponent(v) : null)
            .filter(item => item !== null) as string[];

        if (this.getOperatorId()) {
            data.push('operator-id=' + this.getOperatorId());
        }

        return data.join('&');
    }

    static getPublic(): string {
        return this.publickey;
    }

    static setPublic(publickey: string): void {
        this.publickey = publickey;
    }

    static setOperatorId(operatorId: number | null): void {
        this.operatorid = operatorId;
    }

    static getOperatorId(): number | null {
        return this.operatorid;
    }

    static getBasicAuth(): string {
        return this.basicauth;
    }

    static setBasicAuth(user: string, pass: string): void {
        this.basicauth = 'Basic ' + btoa([user, pass].join(':'));
    }
}

class ApiErrorHandling {
    static apiError(status: number, description: string): void {
        if (status !== 200 && status !== 302 && status !== 401) {
            // console.error('An error is occurred: ('+ status +') '+ description);
        }
    }

    static localError(e: any): void {
        if (e instanceof Error && e.name.toLowerCase().trim() !== 'aborterror') {
            console.error(e);
        } else {
            console.info(e);
        }
    }

    static request(response: Response): void {
        this.apiError(response.status, response.statusText);
    }
}

export const makeAbortablePOST = <T = any>(
    url: string, 
    data: any = {}, 
    options: RequestInit = {}, 
    outputDecoratorFunction: (o: any) => T = (o) => o
): AbortableRequest<T> => {
    options.method = options.method || 'POST';

    if (!options.headers) {
        options.headers = {};
    }

    const headers = options.headers as Record<string, string>;
    headers['Content-Type'] = headers['Content-Type'] || 'application/x-www-form-urlencoded;charset=UTF-8';

    // Se data è un oggetto, filtriamo i valori null/undefined. 
    // Se è già una stringa (come prodotta da postAsGetData), la passiamo a URLSearchParams.
    const params = new URLSearchParams(data);
    const keysToDelete: string[] = [];

    params.forEach((value, key) => {
        if (value === '' || value === null || value === 'null' || value === 'undefined') {
            keysToDelete.push(key);
        }
    });

    keysToDelete.forEach(key => params.delete(key));
    options.body = options.body || params.toString();

    return makeAbortableRequest(url, options, outputDecoratorFunction);
};

export const makeAbortableGET = <T = any>(
    url: string, 
    options: RequestInit = {}, 
    outputDecoratorFunction: (o: any) => T = (o) => o
): AbortableRequest<T> => {
    return makeAbortableRequest(url, options, outputDecoratorFunction);
};

export const makeAbortableRequest = <T = any>(
    url: string, 
    options: RequestInit, 
    outputDecoratorFunction: (o: any) => T
): AbortableRequest<T> => {
    const publickey = (url.indexOf('?') !== -1 ? '&' : '?') + 'public=' + ApiConfig.getPublic();
    const controller = new AbortController();

    options.signal = controller.signal;
    options.credentials = options.credentials || 'include';

    if (!options.headers) {
        options.headers = {};
    }

    const headers = options.headers as Record<string, string>;

    if (ApiConfig.getBasicAuth() !== '') {
        headers['Authorization'] = ApiConfig.getBasicAuth();
    }

    const authToken = window.safeSessionStorage.getItem('SF-Auth-Token');

    if (authToken) {
        headers['X-Auth-Token'] = authToken;
    }

    return {
        abort: () => controller.abort(),
        ready: (rawresponsecallback?: (res: Response) => void) => 
            fetch(url + publickey, options)
                .then(response => {
                    ApiErrorHandling.request(response);

                    if (rawresponsecallback) {
                        rawresponsecallback(response);
                    }

                    const newToken = response.headers.get('X-Auth-Token');
                    if (newToken !== null) {
                        window.safeSessionStorage.setItem('SF-Auth-Token', newToken);
                    }

                    return response.text();
                })
                .then(body => {
                    let output: any = {};

                    if (body.length) {
                        try {
                            output = JSON.parse(body);
                        } catch (e) {
                            output = body;
                        }
                    }

                    return outputDecoratorFunction(output);
                })
                .catch(e => {
                    ApiErrorHandling.localError(e);
                })
    };
};